import React from "react";
import { Link } from "redux-little-router";
import { Grid } from "luna-react/components/grid";
import { Card } from "luna-react/components/card";

import Tabs from "../common/Tabs";

import "./scss/DataGlance.scss";

import personalDataShare from "../../assets/images/tab-images/personal_data_sharing.jpg";
import personalDataWeHold from "../../assets/images/tab-images/personal_data_we_hold.jpg";
import whatIsPersonalData from "../../assets/images/tab-images/what_is_personal_data.jpg";
import howWeKeepDataSecure from "../../assets/images/tab-images/how_we_keep_your_data_secure.jpg";
import howWeUsePersonalData from "../../assets/images/tab-images/how_we_use_your_personal_data.jpg";

export const DataGlance = () => {
  return (
    <Card className="data_glance__wrapper">
      <div className="section_header center-text">
        <h1 className="section_title">Your data at a glance</h1>
        <div className="section_subtext">
          <div>
            Learn more about how we collect, hold and protect your data.
          </div>
          <div>
            Visit our <Link href="/privacy-policy">Privacy Policy</Link> for
            more information.
          </div>
        </div>
      </div>

      <Tabs items={tabContents} />
    </Card>
  );
};

export const tabContents = [
  {
    title: "Who are we?",
    content: (
      <div>
        <p>
          The Sainsbury’s Group includes Sainsbury’s Supermarkets, Argos, Tu
          Clothing, Habitat, Nectar Loyalty Limited, Sainsbury’s Bank and Argos
          Financial Services. You would provide us with your data when visiting
          any of our services below.
        </p>
        <div className="brands__wrapper">
          <Grid.Wrapper matrix horizontalAlign="center">
            <Grid.Item
              className="brand center-text"
              size={{ xs: "1/2", sm: "1/3", md: "1/4" }}
            >
              <div className="brand_logo brand_logo--sainsburys" />
              <h4 className="brand_name">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.sainsburys.co.uk/"
                >
                  Sainsbury's
                </a>
              </h4>
            </Grid.Item>
            <Grid.Item
              className="brand center-text"
              size={{ xs: "1/2", sm: "1/3", md: "1/4" }}
            >
              <div className="brand_logo brand_logo--argos" />
              <h4 className="brand_name">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.argos.co.uk/"
                >
                  Argos
                </a>
              </h4>
            </Grid.Item>
            <Grid.Item
              className="brand center-text"
              size={{ xs: "1/2", sm: "1/3", md: "1/4" }}
            >
              <div className="brand_logo brand_logo--habitat" />
              <h4 className="brand_name">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.habitat.co.uk/"
                >
                  Habitat
                </a>
              </h4>
            </Grid.Item>
            <Grid.Item
              className="brand center-text"
              size={{ xs: "1/2", sm: "1/3", md: "1/4" }}
            >
              <div className="brand_logo brand_logo--tu" />
              <h4 className="brand_name">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://tuclothing.sainsburys.co.uk/"
                >
                  Tu Clothing
                </a>
              </h4>
            </Grid.Item>
            <Grid.Item
              className="brand center-text"
              size={{ xs: "1/2", sm: "1/3", md: "1/4" }}
            >
              <div className="brand_logo brand_logo--sainsburys_bank" />
              <h4 className="brand_name">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.sainsburysbank.co.uk/"
                >
                  Sainsbury's Bank
                </a>
              </h4>
            </Grid.Item>
            <Grid.Item
              className="brand center-text"
              size={{ xs: "1/2", sm: "1/3", md: "1/4" }}
            >
              <div className="brand_logo brand_logo--afs" />
              <h4 className="brand_name">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.argos.co.uk/webapp/wcs/stores/servlet/CreditAndInsuranceView?langId=110&storeId=10151"
                >
                  Argos Financial Services
                </a>
              </h4>
            </Grid.Item>
            <Grid.Item
              className="brand center-text"
              size={{ xs: "1/2", sm: "1/3", md: "1/4" }}
            >
              <div className="brand_logo brand_logo--nectar" />
              <h4 className="brand_name">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.nectar.com/"
                >
                  Nectar
                </a>
              </h4>
            </Grid.Item>
          </Grid.Wrapper>
        </div>
      </div>
    ),
  },
  {
    title: "What is personal data?",
    content: (
      <div>
        <p>
          Personal data is any information that identifies someone and any
          information related to them. For example, your name or account numbers
          identify you, and your interactions with us are related to you.
        </p>
        <p>All of that is your personal data.</p>
      </div>
    ),
    image: whatIsPersonalData,
  },
  {
    title: "What personal data do we hold?",
    content: (
      <div>
        <p>
          We hold different personal data about you depending on your
          relationship with us. Such as:
        </p>
        <ul>
          <li>
            The information that you provide to us when you open accounts or
            place orders
          </li>
          <li>Records of the communications between us</li>
          <li>
            Information about the services that we provide to you and how you
            use them
          </li>
          <li>
            Information required to make decisions about applications you have
            made for financial services products we offer
          </li>
          <li>Account login details for our services</li>
          <li>A record of your marketing preferences</li>
          <li>CCTV images, if you visit our premises</li>
        </ul>
        <p>
          Information from other sources such as specialist companies that
          provide customer information and information that is publicly
          available
        </p>
      </div>
    ),
    image: personalDataWeHold,
  },
  {
    title: "How we use your personal data",
    content: (
      <div>
        <p>
          We use your personal data for different purposes and this depends on
          our relationship with you. It includes:
        </p>
        <ul>
          <li>
            To provide you with our products and services, such as using your
            address so we can make a delivery to you
          </li>
          <li>To personalise your shopping experience</li>
          <li>
            To help provide safe and secure environments for our colleagues to
            work in, our customers to shop in and for our businesses to be
            conducted
          </li>
          <li>
            For statistical analysis and to help us understand more about our
            customers
          </li>
          <li>
            To contact you for marketing purposes, market research, in relation
            to your accounts, your purchases or about questions you have raised
            with us
          </li>
        </ul>
      </div>
    ),
    image: howWeUsePersonalData,
  },
  {
    title: "Who we share your personal data with",
    content: (
      <div>
        <p>
          Where appropriate we share personal data with the Sainsbury's Group
          and with our trusted service providers. In limited circumstances we
          may share your information with other parties, such as, if we are
          required to do so by law or where we are asked by a public or
          regulatory authority.
        </p>
        <p>
          We may also share your information if we need to exercise or protect
          our legal rights, users, systems and services or the rights of others
        </p>
      </div>
    ),
    image: personalDataShare,
  },
  {
    title: "How we keep your personal data safe",
    content: (
      <div>
        <p>
          We’re serious about protecting your personal data and we’re always
          developing our security systems and processes. Some of the controls we
          have in place include;
        </p>
        <ul>
          <li>Limiting user access to our systems</li>
          <li>Technology controls such as firewalls</li>
          <li>Strong data encryption</li>
          <li>Proactive monitoring of our systems</li>
          <li>We limit physical access to our buildings</li>
          <li>We enforce a “need to know” policy for access to any data.</li>
        </ul>
      </div>
    ),
    image: howWeKeepDataSecure,
  },
];

export default DataGlance;



// WEBPACK FOOTER //
// ./src/components/pages/DataGlance.js